import { useCallback } from "react";
import { useAsu, toFakeUtcISO } from "@framework/provider-asu";

export const useToFakeUtcISO = () => {
  const { dbTz } = useAsu();
  return useCallback((date: Date | string) => toFakeUtcISO(date, dbTz), [dbTz]);
};
